// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","lightBulb":"_1ROSo","gold":"_3dLKP"};